import SummaryCard from './SummaryCard.component';

export default SummaryCard;
